<template>
  <div id="main">
    <section class="container">
      <BotWindow
        ref="bot"
        :is-open="visible"
        :colors="$site.colors"
        :on-close="close"
        :is-mobile="mobile"
        :placement="placement"
      >
        <div class="sc-route relative">
          <slot />

          <client-only>
            <LayoutElementsCookie v-if="$site.settings.showCookieConsent" />
          </client-only>
        </div>
      </BotWindow>

      <BotLauncher :open="open" :close="close" :placement="placement" :is-open="visible" :colors="$site.colors" />
    </section>
  </div>
</template>

<script setup lang="ts">
import Utils from '@/utils'

const { $auth, $site } = useNuxtApp()

const layoutStore = useLayoutStore()

const visible = ref(false)
const didCloseTimer = ref()
const didOpenTimer = ref()
const mobile = ref(false)

useHead({
  htmlAttrs: {
    class: 'layout-bot'
  }
})

const placement = computed(() => {
  return layoutStore.botPlacement
})

const router = useRouter()

router.afterEach((to, from) => {
  if (Utils.browser.inIframe() && window.parent) {
    window.postRobot?.send(window.parent, 'bookapp.event.url-changed', to.fullPath)
    if (to && from && to.path !== from.path) {
      window.postRobot?.send(window.parent, 'bookapp.event.page-changed', to.fullPath)
    }
  }
})

onMounted(() => {
  $site.events.$on('_bookapp.bot.close', () => {
    close()
  })

  window.postRobot.on('bookapp.bot.open', { window: window.parent }, () => {
    open()
  })

  window.postRobot.on('bookapp.bot.close', { window: window.parent }, () => {
    close()
  })

  window.postRobot.on('bookapp.bot.reset', { window: window.parent }, () => {
    navigateTo('/bot')
  })

  window.postRobot.on('bookapp.bot.resize', { window: window.parent }, (event: any) => {
    if (event.data.width && event.data.width < 450) {
      mobile.value = true
    } else {
      mobile.value = false
    }

    return {
      mobile: mobile.value
    }
  })

  if ($site.isEmbed && window.parent) {
    window.postRobot?.send(window.parent, 'bookapp.bot.event.ready')
  } else {
    navigateTo('/')
  }
})

const open = () => {
  clearTimeout(didCloseTimer.value)

  $auth.info()

  if (window.parent) {
    window.postRobot?.send(window.parent, 'bookapp.bot.event.willOpen').then(() => {
      visible.value = true

      didOpenTimer.value = setTimeout(() => {
        window.postRobot?.send(window.parent, 'bookapp.bot.event.didOpen').then(() => {

        })
      }, 300)
    })
  }
}

const close = () => {
  clearTimeout(didOpenTimer.value)

  if (window.parent) {
    window.postRobot?.send(window.parent, 'bookapp.bot.event.willClose').then(() => {
      visible.value = false

      didCloseTimer.value = setTimeout(() => {
        window.postRobot?.send(window.parent, 'bookapp.bot.event.didClose').then(() => {

        })
      }, 300)
    })
  }
}
</script>

<style>
html.layout-bot #__layout {
    overflow-x: hidden;
}

.slide-left-leave-active {
  transition: 0.2s;
}
.slide-left-enter-active {
  transition: 0.3s;
}
.slide-left-enter {
  transform: translate(20%, 0);
  opacity: 0
}

.slide-left-enter, .slide-left-enter-active {
}

.slide-left-leave, .slide-left-leave-active {
}

.slide-left-leave-to {
  transform: translate(-20%, 0);
  opacity: 0
}

.slide-left-enter-to {
  opacity: 1
}

.slide-right-leave-active
{
  transition: 0.2s;
}
.slide-right-enter-active
{
  transition: 0.3s;
}
.slide-right-enter {
  transform: translate(-20%, 0);
  opacity: 0
}

.slide-right-enter, .slide-right-enter-active {
}

.slide-right-leave, .slide-right-leave-active {
}

.slide-right-leave-to {
  transform: translate(20%, 0);
  opacity: 0
}

.slide-right-enter-to {
  opacity: 1
}

html.layout-bot body {
  background-color: transparent !important;
}

.sc-route {
  overflow-x: hidden;
  height: 100%;
}
</style>
